module.exports = __webpack_public_path__ + "static/media/combine.603c5149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Pricing/combine.jpg
// module id = 651
// module chunks = 0